

const estilo_coluna_fixo = {
  backgroundColor: 'white',
  position: 'sticky !important',
  zIndex: '1 !important',
}

export default [
  {
    text: 'Departamentos',
    value: 'descricao_linha',
    arrastavel: false,
    ativa: true,
    fixa: true,
    sortable: false,
    style: {
      ...estilo_coluna_fixo,
      minWidth: '250px',
      right: 'auto',
      left: 0,
      borderRight: '2px solid rgba(0,0,0,.1)',
    }
  },
  {
    text: '',
    value: 'nivel_servico',
    arrastavel: false,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '20px'
    }
  },
  {
    text: 'Código',
    value: 'idproduto',
    arrastavel: true,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '60px'
    }
  },
  {
    text: 'Margem',
    value: 'margem',
    arrastavel: true,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '60px'
    }
  },
  {
    text: 'Projeção de vendas',
    value: 'projecao_de_venda',
    arrastavel: true,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '120px'
    }
  },
  /*
  {
    text: 'Dias de gatilho',
    value: 'dias_gatilho',
    arrastavel: true,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '95px'
    }
  },
   */
  {
    text: 'Estoque em Loja',
    value: 'estoque_loja',
    arrastavel: true,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '100px'
    }
  },
  {
    text: 'Cobertura Loja',
    value: 'dias_de_cobertura_da_loja',
    arrastavel: true,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '95px'
    }
  },
  {
    text: 'Estoque no CD',
    value: 'estoque_cd',
    arrastavel: true,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '95px'
    }
  },
  {
    text: 'Cobertura CD',
    value: 'dias_de_cobertura_da_cd',
    arrastavel: true,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '100px'
    }
  },
  {
    text: 'Estoque geral',
    value: 'estoque',
    arrastavel: true,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '90px'
    }
  },
  {
    text: 'Cobertura geral',
    value: 'cobertura_geral',
    arrastavel: true,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '100px'
    }
  },
  {
    text: 'Última entrada',
    value: 'data_da_ultima_entrada',
    arrastavel: true,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '100px'
    }
  },
  {
    text: 'Última venda',
    value: 'data_da_ultima_venda',
    arrastavel: true,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '95px'
    }
  },
  {
    text: 'Pedido pendente',
    value: 'qtde_pendente',
    arrastavel: true,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '110px'
    }
  },
  {
    text: 'Prazo médio de recebimento',
    value: 'prazo_medio_recebimento_em_dias',
    arrastavel: true,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '170px'
    }
  },
  {
    text: 'Cobertura estoque Futura',
    value: 'cobertura_estoque_futura',
    arrastavel: true,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '155px',
    }
  },
  {
    text: 'Estoque em Loja a preço de custo R$',
    value: 'estoque_loja_em_preco_de_custo',
    arrastavel: true,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '210px'
    }
  },
  {
    text: 'Estoque no CD a preço de custo R$',
    value: 'estoque_cd_em_preco_de_custo',
    arrastavel: true,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '200px'
    }
  },
  {
    text: 'Estoque geral a preço de custo R$',
    value: 'estoque_em_preco_de_custo',
    arrastavel: true,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '200px'
    }
  },
  {
    text: 'Estoque geral a preço de venda R$',
    value: 'estoque_em_preco_de_venda',
    arrastavel: true,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '200px'
    }
  },
  // {
  //   text: 'Estoque notificado',
  //   value: 'estoque_notificado',
  //   arrastavel: true,
  //   ativa: true,
  //   sortable: false,
  //   style: {
  //     minWidth: '115px'
  //   }
  // },
  {
    text: 'Projeção de vendas a preço de custo R$',
    value: 'projecao_de_venda_em_preco_custo',
    arrastavel: true,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '230px'
    }
  },
  // {
  //   text: 'Prazo médio de pagamento',
  //   value: 'prazo_medio_pagamento_em_dias',
  //   arrastavel: true,
  //   ativa: true,
  //   sortable: false,
  //   style: {
  //     minWidth: '170px'
  //   }
  // },
  {
    text: 'Pedido pendente a preço de custo R$',
    value: 'pedidos_pendentes_em_preco_custo',
    arrastavel: true,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '220px'
    }
  },
  /*
  {
    text: 'Rentabilidade R$',
    value: 'rentabilidade',
    arrastavel: true,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '110px',
    }
  },
   */
  {
    text: 'Sugestão de Compra R$',
    value: 'sugestao_compra_em_preco_de_custo',
    arrastavel: true,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '140px',
    }
  },
  {
    text: 'Desvio Padrão Consumo',
    value: 'desvio_padrao_consumo',
    arrastavel: true,
    ativa: true,
    sortable: false,
    style: {
      minWidth: '160px',
    }
  },
  {
    text: 'Sugestão de Compra',
    value: 'sugestao_compra_em_quantidade',
    arrastavel: false,
    ativa: true,
    fixa: true,
    sortable: false,
    style: {
      ...estilo_coluna_fixo,
      minWidth: '190px',
      maxWidth: '190px',
      right: 0,
      left: 'auto',
      paddingLeft: '11px',
      border: 0,
      borderLeft: '2px solid rgba(0,0,0,.1)',
    },
  },
]
